/**********************************************************************************
CHID       WHO         WHEN            WHY
********************************************************************************
CHID-1     Usha        20/02/2020      2565:Input validation Issue with gemtriageapi-qa3 GET /api/GemTriage/NLPProcessor/1/fw/ever
*********************************************************************************/
import {Trans} from 'react-i18next'
import i18next from 'i18next';

export function specialCharactersValidation(validationText, validationMsgId) {
    document.getElementById(validationMsgId).innerText = ""
//    let regex = /^[a-zA-Z0-9,.!? ]*$/;
//     let isValid = regex.test(validationText);
//     if (!isValid) {
//         document.getElementById(validationMsgId).innerText = "Special characters are not allowed." ;
//          }
//     return isValid;
let isValid
if(validationText.indexOf("/") > -1){
    
    document.getElementById(validationMsgId).innerText =i18next.t("findcareoption.ValidationMsgInNLPSearch")
    return isValid=false
}
else  {
   
return isValid=true
}
}

